import { SUPPORTED_NETWORK_ERROR } from '../constants/vsb-enums';
import collapsedLogger from '../helpers/collapsed-logger';
import OrchCustomData from './orch-custom-data';

/*
* API to provide supportedCardNetworks for VSB use case. This API will reside in V namespace
* Based on successful init, card networks will be stored in orch custom data
*/
const getSupportedNetworks = () => {
  return new Promise(resolve => {
    let supportedCardNetworks = OrchCustomData?.initSuccessfulNetworks;
    //To put VISA on top of supportedCardNetworks list
    supportedCardNetworks = supportedCardNetworks?.sort()?.reverse() || [];
    collapsedLogger(' VSB getSupportedNetworks =>', supportedCardNetworks);
    if (supportedCardNetworks.length) {
      resolve({ supportedCardNetworks });
    } else {
      collapsedLogger(' VSB getSupportedNetworks Error =>');
      const { message, reason } = SUPPORTED_NETWORK_ERROR;
      resolve({
        error: {
          message,
          reason
        },
        supportedCardNetworks
      });
    }
  });
};

export default getSupportedNetworks;
